import logoDark from "../../../assets/logo-dark.png";
import logoLight from "../../../assets/logo-light.png";
import { useTheme } from "../../../contexts/theme";

interface CopigoLogoProps {
  className?: string;
}

/**
 * The Copigo lockup in the variant that reads on the current theme -
 * logo-dark.png is the light-on-transparent one, for dark backgrounds.
 */
export const CopigoLogo = ({ className }: CopigoLogoProps) => {
  const { isDarkMode } = useTheme();

  return <img className={className} src={isDarkMode ? logoDark : logoLight} alt="Copigo" />;
};
